import React from 'react'
import Contact from '../components/Contact'
const Others = () => {
  return (
   <>
   <Contact/>
   </>
  );
}

export default Others
